import { render, staticRenderFns } from "./solutionMobile.vue?vue&type=template&id=45ff6e0b&scoped=true"
import script from "./solutionMobile.vue?vue&type=script&lang=js"
export * from "./solutionMobile.vue?vue&type=script&lang=js"
import style0 from "./solutionMobile.vue?vue&type=style&index=0&id=45ff6e0b&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "45ff6e0b",
  null
  
)

export default component.exports